<template>
  <div
    class="win_item"
    :class="`item${id} ${onClass}`"
    ref="treeData"
  >
    <div class="jl_con_wrap">
      <div class="jl_con" >
        <div class="img_wrap" v-for="a in imgArr" :key="a.index">
          <span class="img_tip">{{ getTip(a.AwardId) }}</span>
          <img
            :src="getImg(a.AwardId, a.AwardType)"
            width="60"
            height="60"
          />
          <span class="jl_nums" v-show="a.AwardId > 0 && a.AwardType > 0">{{ a.Amount == 3650 ? 1 : a.Amount }}</span>
        </div>
      </div>
    </div>
    <div class="win_nums">{{ 12000 + (drawNum + sumNum + 1)*2000}}</div>
    <a href="javascript:;" class="lq_btn" :class="addClass" @click="getAward(id)">
      <span class="num_tip" v-show="sumNum > 0">{{sumNum}}</span>
    </a>
  </div>
</template>

<script setup>
import { defineProps,computed, onMounted} from 'vue';
import http from '@/utils/request';
import getTip from "@/utils/global";
import emitter from '@/utils/bus';
import {storeToRefs} from 'pinia';
import { useStore } from '../store/index';
const store = useStore();
let {currWinNums,sumNum,drawNum,btnState} = storeToRefs(store);
const props = defineProps({
    id: Number,
    imgArr: Array,
    winMax: Number,
})

  const addClass = computed(()=>{
        if (sumNum.value <= 0) return "cant";
        else return "";
  })

  const onClass = computed(()=>{
        if (
          currWinNums.value >= props.winMax &&
          sumNum.value > 0
        ){
          return "on";
        }
       return "cant";
  })

  onMounted(()=>{
   
  })

  const getImg = function(AwardId, AwardType){
    if (AwardId > 0 && AwardType > 0) {
        if(AwardType ==4){return ""}
        else{
          return require(`@/assets/img/${AwardId}_${onClass.value}.png`);
        }
    }
    return ""
  }
  const getAward = function(id){
      if (sumNum.value <= 0) {
        return;
      }
      if(!btnState.value) return;
        btnState.value = false;
        http.get("ActTask/DrawActTask", {
          params: {
            Id: id,
          },
        })
        .then((res) => {
          if (res.Code == 0) {
              store.updateDrawNum();
              store.updateSumNum();
              btnState.value = true;
              emitter.emit("showaward", {msg:res.Obj, msgtype:2, update:sumNum.value, id:id});

            try {
              window.parent.leftDH.isOnceArr[1] = true;
            } catch (e) {
              console.log(e);
            }
          } else {
            btnState.value = true;
            emitter.emit("showaward", {msg:res.Msg, msgtype:3});
          }
        });
    
  }


</script>

<style scoped>
.win_item{
  width:96px;
  position: relative;
  z-index: 8;
}
.jl_con {
  width:96px;
  height:412px;
}


.win_item .img_wrap{
  padding:3px;
  position: relative;
  width:60px;
  height: 60px;
  margin: 0 auto 11px;
  background: url("../assets/img/img_bg.png") 0 0 no-repeat;
}
.win_item .img_wrap img{
  border-radius: 50%;
}

.win_item .img_wrap .img_tip{
  background: rgb(24 34 40 / 60%);
  position: absolute;
  color:#fff;
  font-size: 12px;
  line-height: 16px;
  min-width: 220px;
  display: none;
  bottom:0;
  right: 0;
  z-index: 10;
  padding:0 5px;
  border:#212d34 1px solid;
  text-align: left;
}
.win_item .img_wrap:hover .img_tip{
  display: block;
}
.win_item .img_wrap .jl_nums {
  position: absolute;
  bottom:-2px;
  width: 40px;
  left:13px;
  text-align: center;
  color: #5d8235;
  font-weight: bold;
  font-size: 12px;
  height: 14px;
  line-height: 14px;
  z-index: 6;
  background: url("../assets/img/bg_num.png") 0 0 no-repeat;
}
.win_item .lq_btn {
  margin:0 0 0 1px;
  position: relative;
  display: block;
  width: 96px;
  height: 32px;
  background: url("../assets/img/lq_btn.png") 0 0 no-repeat;
}
.win_item .lq_btn:hover {
  background-position: 0 -32px;
}
.win_item .lq_btn:active {
  background-position: 0 -64px;
}
.win_item .lq_btn.cant {
  background-position: 0 -128px;
}
.win_nums {
  color: #5a752f;
  font-size: 14px;
  width: 96px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin:0 0 0 1px;
  font-weight: bold;
}

.num_tip {
  position: absolute;
  color: #fff;
  background: url("../assets/img/img_bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
  width: 24px;
  height: 24px;
  top: -6px;
  right: -6px;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  border-radius: 50%;
}

/* .img_wrap .gray {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
} */

</style>
